import { render, staticRenderFns } from "./bindRealCard.vue?vue&type=template&id=6f02e9cf&scoped=true&"
import script from "./bindRealCard.vue?vue&type=script&lang=js&"
export * from "./bindRealCard.vue?vue&type=script&lang=js&"
import style0 from "./bindRealCard.vue?vue&type=style&index=0&id=6f02e9cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f02e9cf",
  null
  
)

export default component.exports